<template>
  <a-modal
    :closable="false"
    :title="$t('page_ops_customer_shared_device')"
    :visible="visible"
    :width="700"
  >
    <a-alert
      :message="$t('page_ops_customer_after_shared') + '！'"
      type="info"
      show-icon
      style="margin-bottom: 8px"
    />
    <a-transfer
      :data-source="mockData"
      :list-style="{
        width: '300px',
        height: '400px',
        overflow: 'auto'
      }"
      :showSelectAll="true"
      :titles="[
        $t('page_ops_customer_no_shared_devices'),
        $t('page_ops_customer_is_shared_devices')
      ]"
      showSearch
      :target-keys="targetKeys"
      :render="renderItem"
      @change="handleChange"
    />
    <template slot="footer">
      <a-button @click="cancel">
        {{ $t('cancel') }}
      </a-button>
      <a-button class="buttom-save-primary" :loading="loading" @click="ok">
        {{ $t('save') }}
      </a-button>
    </template>
  </a-modal>
</template>

<script>
import { MachineServiceProxy } from '@/service-proxies/app-v2/workStation.service-proxies'

const msp = new MachineServiceProxy()

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    customerId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      mockData: [],
      targetKeys: []
    }
  },
  watch: {
    visible: {
      handler() {
        if (this.visible) {
          this.getCustomerMachineList()
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    async getCustomerMachineList() {
      const list = await this.getMachineList()
      if (list && list.length) {
        this.getMock(list)
      }
    },
    async getMachineList() {
      const filter = {
        customerId: this.customerId,
        isAssigned: true,
        assemblyState: '',
        deviceTypeId: ''
      }
      return await (await msp.getMachineList(1, filter, -1)).records
    },
    getMock(list) {
      this.mockData = list.map((res) => {
        const data = {
          key: res.id,
          title: res.name,
          description: res.code,
          isShared: res.isShared
        }
        if (res.isShared) {
          this.targetKeys.push(res.id)
        }
        return data
      })
    },
    renderItem(item) {
      const customLabel = (
        <span class="custom-item">
          {item.title} - {item.description}
        </span>
      )

      return {
        label: customLabel, // for displayed item
        value: item.title // for title and filter matching
      }
    },
    handleChange(targetKeys) {
      this.targetKeys = targetKeys
    },
    cancel() {
      this.mockData = []
      this.targetKeys = []
      this.$emit('cancel')
    },
    ok() {
      const unTargetKeys = []
      this.mockData.map((res) => {
        if (!this.targetKeys.includes(res.key) && res.isShared) {
          unTargetKeys.push(res.key)
        }
      })
      this.$emit('ok', this.targetKeys, unTargetKeys)
      this.mockData = []
      this.targetKeys = []
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .ant-transfer {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
/deep/ .ant-transfer-list-header {
  background: #f8f8f8;
  font-weight: bold;
}
/deep/ .ant-modal-header {
  background: #f8f8f8;
  font-weight: bold;
}
/deep/ .ant-modal-footer {
  background: #f8f8f8;
}
.buttom-save-primary {
  background-color: #13c2c2 !important;
  border-color: #13c2c2 !important;
  color: #fff;
}
/deep/ .ant-transfer-operation .ant-btn:first-child {
  margin-bottom: 16px;
}
/deep/ .ant-btn-icon-only.ant-btn-sm {
  width: 34px;
  height: 34px;
  padding: 0;
  font-size: 14px;
  border-radius: 0;
}
</style>
